import { InjectionToken } from '@angular/core';

export interface GoogleMapsConfig {
  apiKey: string;
  libraries?: string[];  // default: ['places']
}

export const GOOGLE_MAPS_CONFIG = new InjectionToken<GoogleMapsConfig>('GOOGLE_MAPS_CONFIG');

